<template>
<div class="table-responsive">
<table width="100%">
    <thead class="text-muted">
        <tr>
            <th width="1%"></th>            
            <th width="2%"></th>
            <th width="22%">CUENTA *</th>
            <th width="20%">CENTRO DE COSTO</th>
            <th width="9%">NRO DOC *</th>
            <th width="22%">DESCRIPCION</th>
            <th width="12%" class="text-end">DÉBITO *</th>
            <th width="12%" class="text-end">CRÉDITO *</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(item, index) in items">
            <td>
                <div class="mt-2">
                    <a href="javascript:void(0)" class="text-muted" title="Eliminar linea" @click="deleteItem(index)">
                    <vue-feather class="size-18" type="trash"></vue-feather></a>
                </div>
            </td>            
            <td class="align-middle text-center">
                <span class="text-muted" style="font-size: large;">{{ index+1 }}</span>
            </td>
            <td class="align-middle">
                <multiselect
                    class="select-items"
                    v-model="item.account_obj"
                    :options="accounts"
                    track-by="id" 
                    :id="index"
                    label="name"
                    @select="(selected) => SelectOption(selected, index)"
                    placeholder="Seleccione"
                    :showLabels="false"
                    :class="item.errorcuenta?'errord':''"
                >
            </multiselect>
            </td>
            <td class="align-middle">
                <multiselect
                    class="select-items"
                    v-model="item.cost_centre_obj"
                    :disabled="item.isdisabled?true:false"
                    :options="cost_centres"
                    :id="index"
                    @select="(selected) => selectCentroCosto(selected, index)"
                    
                    :required="item.isdisabled?false:true"
                    track-by="id" 
                    label="name"
                    placeholder="Seleccione"
                    :showLabels="false"
                    :class="item.errorcost_centro?'errord':''"
                ></multiselect>
            </td>
            <td class="align-middle">
                <input type="text" v-model="item.reference" class="form-control form-control-sm"
                    :class="item.errorreference?'errord':''">
            </td>
            <td class="align-middle">
                <input type="text" v-model="item.description" class="form-control form-control-sm">
            </td>
            <td class="align-middle">
                <vue-number v-model="item.debit" 
                :disabled="toNumber(item.credit) > 0"
                v-bind="number" 
                class="form-control form-control-sm"
                :class="item.errordebit?'errord':''"></vue-number>
          
            </td>
            <td class="align-middle">
                <vue-number v-model="item.credit" 
                :disabled="toNumber(item.debit) > 0"
                v-bind="number" 
                class="form-control form-control-sm"
                :class="item.errorcredit?'errord':''"></vue-number>
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <th colspan="3">
                <div class="input-group col-sm-12 mt-3">
                    <button 
                        type="button" 
                        class="btn btn-xs btn-primary" 
                        @click="addItem()"
                        :disabled="lines==0 || lines>20"
                    > +Agregar líneas (máx. 20)</button>
               <input 
                   type="text" 
                        v-model="lines"
                        @keypress="NumbersOnly"
                        class="form-control form-control-sm">
                </div>
            </th>
            <th colspan="3" class="text-end">Total.:</th>
            <th class="text-end">{{ usd?'$':coin }}{{ formatNumber(totalDebit()) }}</th>
            <th class="text-end">{{ usd?'$':coin }}{{ formatNumber(totalCredit()) }}</th>
        </tr>
        <tr>
            <th colspan="6" class="text-end text-danger">Diferencia.:</th>
            <th colspan="2" class="text-end text-danger">{{ usd?'$':coin }}{{ formatNumber(Math.abs(totalDebit()-totalCredit())) }}</th>
        </tr>
    </tfoot>
  </table>
  <br><br><br><br>
</div>
</template>

<script>    

import Multiselect from 'vue-multiselect'
import VueFeather from 'vue-feather';
import { component as VueNumber } from '@coders-tm/vue-number-format'
import axios from "axios";

export default {
    props: [
        'coin',
        'company_id',
        'items',
        'usd'
    ],
    watch: {
        usd() {
            this.number = {
                ...this.number,
                prefix: this.usd ? '$' : this.coin
            };

            this.items.forEach((_, index) => {
                if (this.toNumber(this.items[index].credit) === 0) this.items[index].credit = "0.00";
                if (this.toNumber(this.items[index].debit) === 0) this.items[index].debit = "0.00";
            });
        }
    },
    components: {
        Multiselect,
        VueFeather,
        VueNumber,
    },        
    data() {
        return {
            lines:10,
            option_lines:[1,2,3,4,5,6,7,8,9,10],
            accounts :[],
            cost_centres :[],
            number: {
  decimal: ",",
  separator: ".",
  prefix: this.usd?'$':this.coin,
  suffix: "",
  prefill:true,
  precision: 2,
  nullValue: "",
  masked: true,
  reverseFill: false,
  minimumFractionDigits: 2
}
        }
    },        
    beforeMount(){
        //
    },
    mounted() {
        this.getAccounts();
        this.getCostCentres();
        console.log('Items mounted.');
    },
    methods: {
        ingressform(type, value, index){

        },onChangedebit(dato,item){

        },SelectOption(selected,id){
            if(Number(selected.cost_centre)){
                this.items[id].isdisabled=false
                this.items[id].errorcost_centro=true
            }else{
                this.items[id].cost_centre_obj=null
                this.items[id].isdisabled=true
                this.items[id].errorcost_centro=false
            }
        },selectCentroCosto(selected,id){
            if(selected){
                this.items[id].errorcost_centro=false
            }
        },
        formatNumber (num) {
            return new Intl.NumberFormat('de-DE',{ minimumFractionDigits: 2 }).format(num);
        },        
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },        
        toNumber(v) {
            if (v === null || v === undefined || v === '') return 0;
            // Si ya viene number
            if (typeof v === 'number') return isNaN(v) ? 0 : v;
            // Convierte a string y quita prefijos/símbolos (Bs, $, espacios, etc.)
            let s = String(v).trim();
            // deja solo dígitos, coma, punto y signo -
            s = s.replace(/[^0-9,.\-]/g, '');
            if (s === '' || s === '-' || s === ',' || s === '.') return 0;
            // Caso típico "1.234,56" -> "1234.56"
            // Si hay coma, asumimos coma decimal y punto miles
            if (s.includes(',')) {
                s = s.replace(/\./g, '').replace(',', '.');
            } else {
                // Si no hay coma, dejamos punto como decimal (y quitamos miles con comas por si acaso)
                s = s.replace(/,/g, '');
            }
            const n = Number(s);
            return isNaN(n) ? 0 : n;
        },
        totalDebit(){
            return this.items.reduce((acc, item) => acc + this.toNumber(item.debit), 0);
        },
        totalCredit(){
            return this.items.reduce((acc, item) => acc + this.toNumber(item.credit), 0);
        },        
        getAccounts(){
            axios.get('../api/companies/'+this.company_id+'/accounts')
            .then((response) => {
                //console.log( response.data.data );
                this.accounts = response.data.data;
            })
            .catch( resonse => {
                console.log('error');
            })
        },
        getCostCentres(){
            console.log('getCostcentres');
            axios.get('../api/companies/'+this.company_id+'/cost_centres')
            .then((response) => {
                //console.log( response.data.data );
                this.cost_centres = response.data.data;
            })
            .catch( resonse => {
                console.log('error');
            })
        },
        addItem(){
            for (let i = 0; i < this.lines ; i++) {
                this.items.push({
                account: '',
                cost_centre: '',
                account_obj: null,
                cost_centre_obj: null,
                isdisabled: true,
                reference: '',
                description: '',
                debit: "0.00",
                credit: "0.00"
                });
            }
        },
        deleteItem: function (index) {
            this.items.splice(index, 1);
        },
        verifyCostCentre: function (item) {
            //this.disabled_cc=(item.cost_centre)?false:true;
        },
    }     
}
</script>

<style>
th {
  font-size: 10pt;
  font-weight: 400;
}

.size-18{
    width: 18px;
    height: 18px;
}
.select-items .multiselect__content-wrapper{
   width: 300px;
}
</style>

  